import * as React from "react";
import Svg, { Circle, Path } from "react-native-svg";

function SvgComponent(props) {
  return (
    <Svg
      width={32}
      height={32}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Circle cx={16} cy={16} r={16} fill="#ECFCE5" />
      <Path
        d="M13.331 15.331a.669.669 0 01-.668-.668v-2a.67.67 0 01.936-.677.669.669 0 01.395.676v2a.67.67 0 01-.663.67zM16 15.331a.669.669 0 01-.669-.668V12a.669.669 0 011.332 0v2.669a.669.669 0 01-.663.662zM18.669 15.331a.669.669 0 01-.669-.668v-3.994a.668.668 0 111.331 0v4a.669.669 0 01-.662.662z"
        fill="#198155"
      />
      <Path
        d="M21.331 26H10.67A2.669 2.669 0 018 23.331V11.25a3.325 3.325 0 011.2-2.563l2.3-1.912A3.344 3.344 0 0113.631 6h7.7A2.668 2.668 0 0124 8.669V23.33A2.669 2.669 0 0121.331 26zm-7.7-18.669c-.457.007-.898.17-1.25.463L10.05 9.713a1.994 1.994 0 00-.719 1.537v12.081a1.338 1.338 0 001.332 1.332H21.33a1.337 1.337 0 001.332-1.332V8.67a1.337 1.337 0 00-1.332-1.332l-7.7-.006z"
        fill="#198155"
      />
      <Path
        d="M20 22h-8a.669.669 0 110-1.331h8A.668.668 0 1120 22zM20 18.669h-8a.669.669 0 010-1.332h8a.668.668 0 110 1.332z"
        fill="#198155"
      />
    </Svg>
  );
}

export default SvgComponent;
